import styled from "styled-components"

/** A small "pill" to show a tag in a usually short list of values, with customisable colours. */
export default styled.span`
  display: inline-block;
  color: ${(props) => props.fgCol || "white"};
  background-color: ${(props) => props.bgCol || "#222"};
  padding: 0.15rem 0.5rem;
  font-size: 0.8rem;
  border-radius: 0.9rem;
  margin: 0 0.15rem;
  height: 1.2rem;
  overflow: hidden;
`
